<div class="container">
    <h1 style="text-align:center">Prenota la tua partenza</h1>

    <ng-container *ngIf="app.curruser.C1">
        <div class="img-top" *ngIf="true">
            <img src="assets/img/golf.jpg" />
        </div>

        <div class="biglietto mt-20 p-30">

            <div class="row px-20 my-20">

                <div class="col-12 col-sm-6 mb-20" style="line-height: 2;" *ngIf="app.curruser">
                    <h5 class="mb-30">Contatti</h5>
                    <div>{{ app.curruser.company }}</div>
                    <div>{{ app.curruser.address }}, {{ app.curruser.zip }} {{ app.curruser.city }} ({{ app.curruser.province }})</div>
                    <div *ngIf="app.curruser.website">Web: <a [href]="'https://' + app.curruser.website">{{ app.curruser.website }}</a></div>
                    <div>Email: {{ app.curruser.email }}</div>
                    <div *ngIf="app.curruser.phone">Telefono: {{ app.curruser.phone }}</div>
                </div>
                <div class="col-12 col-sm-6">
                    <h5 class="mb-30">Quando vuoi giocare?</h5>

                    <mat-form-field class="full-width" style="max-width: 440px">
                        <mat-label>Nome *</mat-label>
                        <input matInput [(ngModel)]="prenotaNome" (change)="checkForm()">
                    </mat-form-field>
                    <div class="row">
                        <div class="col-sm-6" style="max-width: 220px">
                            <mat-form-field class="full-width" style="max-width: 440px">
                                <mat-label>Email *</mat-label>
                                <input matInput [(ngModel)]="prenotaEmail" (change)="checkForm()">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6" style="max-width: 220px">
                            <mat-form-field class="full-width" style="max-width: 440px">
                                <mat-label>Cellulare</mat-label>
                                <input matInput [(ngModel)]="prenotaMobile" (change)="checkForm()">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4" style="max-width: 135px">
                            <mat-form-field class="full-width">
                                <mat-label>Data *</mat-label>
                                <input matInput [(ngModel)]="prenotaData" (change)="checkForm()">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4" style="max-width: 135px">
                            <mat-form-field class="full-width">
                                <mat-label>Fascia oraria *</mat-label>
                                <input matInput [(ngModel)]="prenotaOra" (change)="checkForm()">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4" style="max-width: 135px">
                            <mat-form-field class="full-width">
                                <mat-label>Num posti *</mat-label>
                                <input matInput [(ngModel)]="prenotaPosti" (change)="checkForm()">
                            </mat-form-field>
                        </div>
                    </div>

                    <mat-form-field class="full-width" style="max-width: 440px">
                        <mat-label>Messaggio</mat-label>
                        <textarea matInput [(ngModel)]="prenotaMsg" (change)="checkForm()" style="min-height: 60px;"></textarea>
                    </mat-form-field>

                    <re-captcha #recaptcha (resolved)="resolved($event)" siteKey="6Le7lvYhAAAAAMeOWm5GTZmchc_lsdum6kZvYnkv"></re-captcha>

                    <mat-checkbox class="mt-20 mb-10" [(ngModel)]="privacy" color="primary" (change)="checkForm()" style="font-size:.9rem">
                        {{ 'login.privacy1' | translate }}
                        <span class="link" (click)="openUrl('')">{{ 'login.privacy' | translate }}</span> {{ 'login.privacy2' | translate }}
                    </mat-checkbox>



                    <div class="mt-15" style="width: 100%; display: flex; flex-direction: column;">
                        <div class="mb-5" *ngIf="errorMessage" style="color: red;">{{ errorMessage }}</div>
                        <button style="width: 100px;" mat-button class="container-buy-button shop-button shop-button-label" (click)="invia()">
                            <span class="shop-button-label">{{ 'Invia' | translate }}</span>
                        </button>
                    </div>

                    <!-- TODO: alex -->
                    <!-- aggiungere checkbox privacy default: https://opengolf.it/it/privacy-policy -->
                    <!-- utilizzare il box sotto solo per segnalare errori -->
                    <!-- quando viene fatto l'invio toast success -> email inviata con successo e azzerare i campi -->

                </div>
            </div>

        </div>
    </ng-container>
    <ng-container *ngIf="app.curruser.C1">
        <div class="row">
            <div class="col-12 col-sm-6 flex-center mt-20 text-center">
                <div>
                    <mat-form-field style="margin: 0 15px 0 0; min-width: 200px;">
                        <mat-label>{{ 'Percorsi' | translate }}</mat-label>
                        <mat-select #selectOraBi [(ngModel)]="percorso" color="primary" (selectionChange)="SelectPercorso()" *ngIf="percorsi">

                            <mat-option [value]="0">Seleziona...</mat-option>
                            <mat-option *ngFor="let percorso of percorsi; let i = index" [value]="percorso.id">
                                {{ percorso.descr }}
                            </mat-option>

                        </mat-select>
                    </mat-form-field>

                    <button class="shop-button" style="border-style: none;" (click)="SelectPercorso()">
                        {{ 'Mostra partenze disponibili' | translate }}
                    </button>
                </div>
            </div>

            <div class="col-12 col-sm-6 flex-center mt-20" style="flex-wrap: wrap;">
                <div class="date-carousel">
                    <div class="date-carousel-indietro" (click)="indietro()" *ngIf="app && isIndietroVisible()">
                        &lt;
                    </div>
                    <div *ngFor="let currday of currWeek; let i = index" [class]="currDayActiveIndex == i ? 'date-carousel-item active' : 'date-carousel-item'">
                        <div class="date-carousel-month">{{ utils.getShortMonth(currday.month) }}</div>
                        <div class="date-carousel-day-weekday" [class]="isDayDisabled(i)" (click)="setDataFromCarousel(i)">
                            <div [class]="currday.weekday == 7 ? 'date-carousel-day sunday' : 'date-carousel-day'">
                                {{ currday.day }}
                            </div>
                            <div [class]="currday.weekday == 7 ? 'date-carousel-weekday sunday' : 'date-carousel-weekday'">
                                {{ utils.getShortWeekDay(currday.weekday) }}
                            </div>
                        </div>
                    </div>
                    <div *ngIf="app" [class]="'date-carousel-avanti' + isAvantiDisabled()" (click)="avanti()">
                        &gt;
                    </div>
                    <div class="date-carousel-item search" style="align-self: stretch; padding: 1px;">
                        <div class="date-carousel-month">{{ 'Data' }}</div>
                        <div class="date-carousel-day-weekday" (click)="openDatePicker($event, 'DaData')" style="height: 100%;">
                            <div class="date-carousel-day" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                                <mat-icon style="font-size: 30px; height: auto; width: auto;">search</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-20" *ngIf="partenze && partenze.length > 0">
                    <div class="col-12 col-sm-6">
                        <b>Carrelli: </b><span>{{ dispCarrelli }}</span>
                    </div>
                    <div class="col-12 col-sm-6">
                        <b>Carrelli Elettrici: </b><span>{{ dispCarrelliEl }}</span>
                    </div>
                    <div class="col-12 col-sm-6">
                        <b>Golf Car: </b><span>{{ dispGolfcar }}</span>
                    </div>
                    <div class="col-12 col-sm-6">
                        <b>Sacche: </b><span>{{ dispSacche }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!--
        <div class="row mt-20">
            <div class="col-12 col-sm-6 flex-center">
                <mat-checkbox [(ngModel)]="visualizzaNomi" color="primary">
                    {{ 'Visualizza Nomi' | translate }}
                </mat-checkbox>
            </div>
        </div>
        -->

        <div class="biglietto mt-20 py-100 text-center" *ngIf="!partenze || partenze.length === 0">
            <h4 *ngIf="!error && percorsi">Seleziona il giorno e percorso e clicca su "Mostra partenze disponibili"</h4>
            <h4 *ngIf="!error && !percorsi">Seleziona il giorno e clicca su "Mostra partenze disponibili"</h4>
            <h4 *ngIf="error" style="color: #CB2027; text-align: center;" [innerHTML]="error"></h4>

        </div>
        <div class="biglietto mt-20 pt-30" *ngIf="partenze && partenze.length > 0">
            <table class="myTable">
                <tr>
                    <th>Ora</th>
                    <th>Disponibilità</th>
                    <th>Prenota</th>
                </tr>
                <tr *ngFor="let p of partenze">
                    <td class="orario theme-color" [ngClass]="p.Disp === 0 ? 'orario-nero' : ''">
                        {{ utils.To2digit(p.Ore) }}:{{ utils.To2digit(p.Minuti) }}
                    </td>
                    <td class="disp">
                        <span *ngIf="p.Disp > 0">{{ p.Disp }}</span>
                        <span *ngIf="p.Disp === 0">COMPLETO</span>
                        <div *ngIf="visualizzaNomi && p.Nomi" [innerHTML]="utils.ReplaceAll(p.Nomi, ',', ', ')" class="nomi"></div>
                    </td>
                    <td class="prenota">
                        <button *ngIf="p.Disp > 0 && p.Prenotabile" mat-flat-button color="primary" (click)="Prenota(p)" style="background-color: #265079;border-radius: 20px">
                            {{ 'Prenota' | translate }}
                        </button>
                        <!-- <ion-icon *ngIf="p.Disp > 0 && p.Prenotabile" name="arrow-forward-circle" class="fab-btn" (click)="Prenota(p.IDPartenza)"></ion-icon> -->
                    </td>
                </tr>
            </table>
        </div>

    </ng-container>
    <!--
    <div *ngIf="partenze && partenze.length > 0 && !isSocio" class="mt-16">
        Per prenotare una partenza devi essere abilitato dal tuo circolo.
        <br /><br />
        <div class="text-center">
            <button (click)="onInviaRichiesta()" color="primary">
                Invia richiesta
            </button>
        </div>

        <div *ngIf="richiestaInviata" style="padding: 16px 10px">
            <strong>Richiesta inviata con successo!</strong>
            <br />Riceverai una email appena vieni abilitato alle prenotazioni
        </div>
    </div>
    -->

    <app-credits [configApp]="app" *ngIf="app"></app-credits>


</div>